import { render, staticRenderFns } from "./terms-of-agreements.vue?vue&type=template&id=26c4f364&scoped=true&"
import script from "./terms-of-agreements.vue?vue&type=script&lang=js&"
export * from "./terms-of-agreements.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-agreements.vue?vue&type=style&index=0&id=26c4f364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c4f364",
  null
  
)

export default component.exports